<template>
    <div>
        <h1 style="font-size: 24px; color: black;"><el-page-header @back="goBack" content="活动配置">
        </el-page-header></h1>
        <el-card  shadow="never">
            <el-col style="padding-bottom: 15px">位置名称：{{position.name}}
              <el-button class="sub-sub12" type="primary" @click="showDetail('新增活动')">新增活动</el-button>
            </el-col>
        </el-card>
        <h1>
            <el-table :data="activityList"
                      border
                      :fit="true">
                <el-table-column label="活动ID" prop="id" align="center"></el-table-column>
                <el-table-column label="活动名称" prop="name" align="center"></el-table-column>
                <el-table-column label="跳转类型" prop="jumpTypeEnum.name" align="center"></el-table-column>
                <el-table-column label="游戏id" prop="gameId" align="center"></el-table-column>
                <el-table-column label="H5地址" prop="jumpSuccessUrl" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="图片"  align="center">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.picture" width="80px" height="80px" />
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="显示规则"  align="center" prop="jumpShowRuleEnum.name" show-overflow-tooltip></el-table-column>
                <el-table-column label="渠道"  align="center" width="200px" show-overflow-tooltip>
                    <template slot-scope="scope" >
                        {{ scope.row.subChannelName===0?'':scope.row.subChannelName.join(" , ")}}
                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="state" align="center" ></el-table-column>
                <el-table-column label="限制次数" prop="dialogLimit" align="center"></el-table-column>
                <el-table-column label="排序" prop="ranking" align="center"></el-table-column>
                <el-table-column label="生效时间" prop="startDt" align="center" :formatter="formatDate"></el-table-column>
                <el-table-column label="失效时间" prop="endDt" align="center" :formatter="formatDate"></el-table-column>
                <el-table-column label="操作" align="center" width="180px">
                    <template slot-scope="scope">
                        <el-button plain size="mini" type="success" @click="showDetail('编辑活动',scope.row)">编辑</el-button>
                        <el-button plain size="mini" type="danger" @click="deleteActivity(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </h1>
        <el-row>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="[20,50,100]"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
            </el-pagination>
        </el-row>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="700px">
            <el-form :model="activityEditForm" label-width="150px">
                <el-form-item label="活动名称:" >
                    <el-input  style="width: 300px" type="text" v-model="activityEditForm.name"></el-input>
                </el-form-item>
                <el-form-item label="跳转类型:" >
                    <el-select  v-model="activityEditForm.jumpType">
                        <el-option
                                v-for="item in jumpTypes"
                                :label="item.name"
                                :value="item.id"
                                :key="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  v-if="activityEditForm.jumpType===0" label="游戏Id:" >
                    <el-input-number v-model="activityEditForm.gameId"  :step="1" :min="1" :max="10000"></el-input-number>
                </el-form-item>
                <el-form-item v-if="activityEditForm.jumpType!==0" label="跳转页面:" >
                    <el-input v-model="activityEditForm.jumpSuccessUrl" ></el-input>
                </el-form-item>
                <el-form-item v-if="activityEditForm.jumpType!==0" label="失败页面:" >
                    <el-input v-model="activityEditForm.jumpFailUrl" ></el-input>
                </el-form-item>
                <el-form-item label="图片 :" >
                    <el-tag type="danger">视频不大于1mb</el-tag>
                    <el-upload
                            :headers="headers"
                            class="avatar-uploader"
                            :action="uploadURL"
                            :show-file-list="false"
                            :on-success="handleBISuccess"
                            :before-upload="function (file) { return beforeAvatarUpload(file)}"
                            @click="uploadIcon">
                        <img v-if="activityEditForm.picture" :src="VUE_APP_CDN_URL+activityEditForm.picture" class="avatar">
                        <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="视频 :" >
                    <el-tag type="danger">视频不大于5mb</el-tag>
                    <el-upload
                            class="avatar-uploader "
                            :action="uploadURL"
                            :headers="headers"
                            :show-file-list="false"
                            :on-success="handleVideoSuccess"
                            :before-upload="beforeUploadVideo">
                        <video v-if="activityEditForm.video"  :src="activityEditForm.video"  class="avatar1" controls="controls"></video>
                        <i v-else class="el-icon-video-camera-solid avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="有效期:" >
                    <el-date-picker
                            v-model="activityEditForm.startDt"
                            type="datetime"
                            placeholder="开始时间">
                    </el-date-picker>
                    <span>至</span>
                    <el-date-picker
                            v-model="activityEditForm.endDt"
                            type="datetime"
                            placeholder="结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="显示规则:" >
                    <el-select  v-model="activityEditForm.rule">
                        <el-option
                                v-for="item in ruleTypes"
                                :label="item.name"
                                :value="item.id"
                                :key="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="用户群体:" >
                    <el-select  v-model="activityEditForm.userType">
                        <el-option
                                v-for="item in userTypes"
                                :label="item.name"
                                :value="item.id"
                                :key="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="点击是否关闭:" >
                    <el-radio-group v-model="activityEditForm.clickClose">
                        <el-radio :label="true">开启</el-radio>
                        <el-radio :label="false">关闭</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="关闭按钮:" >
                    <el-radio-group v-model="activityEditForm.closeButton">
                        <el-radio :label="true">开启</el-radio>
                        <el-radio :label="false">关闭</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item   label="弹窗次数:" >
                    <el-input-number v-model="activityEditForm.dialogLimit"  :step="1"></el-input-number>
                </el-form-item>
                <el-form-item v-if="dialogTitle ==='编辑活动'"  label="排序:" >
                    <el-input-number v-model="activityEditForm.ranking"  :step="1"></el-input-number>
                </el-form-item>
                <el-form-item label="渠道筛选 :" >
                    <el-cascader
                            v-model="activityEditForm.subChannels"
                            :options="channelList"
                            :props="optionProps"
                            clearable
                            collapse-tags>
                    </el-cascader>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirm">确 定</el-button>
                    <el-button type="info" @click="dialogVisible=false">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
    import {allOperationPositionActivity,allSelect,gameUpload,channelList,
        editOPActivity,
        deleteOPActivity}
    from  "@/http/api";
    import utils from '@/utils';
    export default {
        name: "OperationConfigDetail",
        data(){
            return{
                position:{},
                headers:{},
                channelList:[],
                uploadURL: process.env.VUE_APP_BASE_URL + "game/upload",
                activityList:[],
                queryTrueData:{},
                VUE_APP_BASE_URL:'',
                VUE_APP_CDN_URL:'',
                userTypes:[],
                ruleTypes:[],
                jumpTypes:[],
                dialogVisible: false,
                dialogTitle :'',
                optionProps: {
                    emitPath: false,
                    multiple: true,
                    value: 'subChannel',
                    label: 'name',
                    children: 'children',
                },
                activityEditForm:{
                },
                page: {
                    size: 20,
                    page: 1,
                    totalElements: null
                },
            }
        },
        methods:{
            formatDate: function(row, column, cellValue) {
                return utils.DateUtil.formatDate(cellValue, "yyyy-MM-DD HH:mm:ss")
            },
            goBack() {
                this.$router.push({path: '/operationConfig'});
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.queryList();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.queryList();
            },
            handleBISuccess(response){
                this.activityEditForm.picture=response.info;
            },
            uploadIcon(){
                let func = gameUpload;
                func().then().catch(function () {
                })
            },
            handleVideoSuccess(response){
                this.activityEditForm.video=response.info;
            },
            beforeAvatarUpload(file) {
                const isIcon = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg'|| file.type === 'image/gif';
                const isLt2M = file.size / 1024 / 1024 < 1;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过1MB!');
                }
                if (!isIcon) {
                    this.$message.error('上传图片只能是png,jgp,jpeg,gif格式!');
                }
                return isIcon && isLt2M;
            },
            beforeUploadVideo(file){
                const isVideo = file.type === 'video/mp4' || file.type === 'video/avi' || file.type === 'video/wmv';
                const  isLt5M = file.size/1024/1024<5;
                if (!isLt5M){
                    this.$message.error('上传视频不能超过5Mb')
                }
                if (!isVideo){
                    this.$message.error('上传视频是能是mp4，avi,wmv格式')
                }
                return isLt5M && isVideo;
            },
            showDetail: function(title,row){
                allSelect().then(resp => {
                    this.userTypes = resp.data.info.userTypes;
                    this.ruleTypes = resp.data.info.ruleTypes;
                    this.jumpTypes = resp.data.info.jumpTypes;
                });
                this.activityEditForm = {
                    "id": 0,
                    "name": "",
                    "gameId":1,
                    "jumpType":0,
                    "operationPositionId":this.position.id,
                    "jumpSuccessUrl":"",
                    "jumpFailUrl":"",
                    "picture":"",
                    "video":"",
                    "startDt":'',
                    "endDt":'',
                    "rule":0,
                    "userType":0,
                    "clickClose":true,
                    "closeButton":true,
                    "subChannels":[],
                    "ranking":1,
                    "dialogLimit":0,
                };

                this.dialogTitle = title;
                this.dialogVisible = true;

                if(row){
                    this.activityEditForm = {
                        "id": row.id,
                        "name": row.name,
                        "gameId":row.gameId,
                        "jumpType":row.jumpType,
                        "operationPositionId":row.operationPositionId,
                        "jumpSuccessUrl":row.jumpSuccessUrl,
                        "jumpFailUrl":row.jumpFailUrl,
                        "picture":row.picture,
                        "video":row.video,
                        "startDt":row.startDt,
                        "endDt":row.endDt,
                        "rule":row.rule,
                        "userType":row.userType,
                        "clickClose":row.clickClose,
                        "closeButton":row.closeButton,
                        "subChannels":row.subChannel,
                        "ranking":row.ranking,
                        "dialogLimit":row.dialogLimit,
                    };
                }
            },
            deleteActivity(id){
                this.$confirm('此操作将删除活动, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteOPActivity(id).then(resp => {
                        if(resp.data.status===0){
                            this.queryList();
                        }
                    });
                }).catch(() => {
                })

            },
            confirm(){
                editOPActivity(this.activityEditForm).then(resp => {
                    if(resp.data.status===0){
                        this.queryList();
                        this.dialogVisible = false;
                    }
                });
            },
            queryList(){
                this.queryTrueData.size = this.page.size;
                this.queryTrueData.page = this.page.page;
                allOperationPositionActivity(this.queryTrueData).then(resp => {
                    this.activityList = resp.data.info.content;
                    this.$forceUpdate();
                    this.page.totalElements = resp.data.info.totalElements;
                });
            },
        },
        created() {
            let _this = this;
            channelList().then(resp => {
                this.channelList = JSON.parse(JSON.stringify(resp.data.info)).map(channel => {
                    if (channel.children) {
                        channel.children = channel.children.filter(sub => sub.state === 1)
                    }
                    return channel;
                }).filter(channel => channel.children && channel.children.length);
                this.channelList.forEach(function (channel) {
                    _this.$set(channel, 'subChannel', channel.id);
                });
            });
            this.headers ={Authorization : this.$store.state.user.token};
            this.position = this.$store.state.position;
            this.queryTrueData.opId = this.$store.state.position.id;
            this.queryList();
        },
        mounted() {
            this.VUE_APP_BASE_URL=process.env.VUE_APP_BASE_URL;
            this.VUE_APP_CDN_URL= process.env.VUE_APP_CDN_URL;
        }
    }
</script>

<style scoped>
    .sub-sub12{ position: relative; left: 1200px}
</style>